__webpack_require__.p = "/security-analytics-kx6tgq/referrals/";